import React from 'react';
import ScrollMagie from '../../helpers/scrollmagie'

export default class detail extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        new ScrollMagie()
    }

    render() {
        return <section>


            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/visualbranding/cover.jpg)"}}>
                <div className="scroll-down-wrapper">
                    <div className="scroll-down">
                        <p>Scroll<br/>down</p>
                        <img src="public/images/scroll.svg" alt=""/>
                    </div>
                </div>
            </div>

            <div className="pb-80">&nbsp;</div>

            <div className="section-wrapper">
                <div className="container">
                    <div className="row relative">
                        <div className="gr-5 no-gutter">
                            <div className="image text-right transform-l-30"
                                 style={{
                                     position: "relative",
                                     zIndex: 1,
                                     marginTop: "-3vw"
                                 }}>
                                <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                    <img src="public/images/visualbranding/collage_1_1.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                        <div className="gr-7 no-gutter">
                            <div style={{
                                position: "relative",
                                zIndex: 2,
                            }}>
                                <div className="animate" data-transform-y="10%" data-transform-duration="100%">
                                    <img src="public/images/visualbranding/collage_1_2.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="gr-2">&nbsp;</div>
                        <div className="gr-4"
                             style={{
                                 position: "relative",
                                 zIndex: 3,
                                 marginTop: "-5vw"
                             }}>
                            <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                <img src="public/images/visualbranding/collage_1_3.jpg" alt=""
                                     className="image-resp"/>
                            </div>
                        </div>
                        <div className="gr-6">
                            <div className="padding-dynamic-left-3 padding-dynamic-top-3">
                                <div className="animate" data-transform-y="10%" data-transform-duration="100%">
                                    <h1 style={{fontSize: "5vw", lineHeight: "5vw"}}>VISUAL<br/>BRANDING</h1>
                                    <div className="width-percent-70">
                                        <p>
                                            Einzigartige und überzeugende Bilder die die Werte und die Persönlichkeit
                                            eines Unternehmens widerspiegeln und damit die Markenidentität des
                                            Unternehmens definieren. Es handelt sich dabei nicht einfach nur um die
                                            Bebilderung einer Website oder eines Geschäftsberichtes, in Summe bestimmen
                                            Sie, wie das Publikum das Unternehmen wahrnimmt. Neben der dafür eigens
                                            kreierten Bildsprache für ein Projekt, konzipiert Joel Kernasenko darüber
                                            hinaus auch die dahinterliegenden Ideen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/visualbranding/full_1.jpg)"}}></div >

            <div>
                <div className="row">
                    <div className="prefix-1 gr-3">
                        <div>
                            <h1 style={{paddingTop: "5vw"}}>AERIAL</h1>
                            <p>
                                Die Aufgabe der Holding Graz ist es, die gesamte Stadt Graz zu organisieren. Sei es im
                                Bereich des öffentlichen Verkehrs, der Wasser- und Abfallwirtschaft oder den gesamten
                                Stadtraum. Sie stellen die Energieversorgung sicher, unterhalten die Freizeit-Betriebe
                                und
                                begleiten die Menschen auf ihrem letzten Weg. Joel Kernasenko´s Idee, dieses logistische
                                Netzwerk mithilfe von Luftaufnahmen zu visualisieren, überzeugte. Für die perfekten
                                Fotos
                                kreiste Joel Kernasenko 5 Stunden über den Dächern von Graz.
                            </p>
                        </div>
                    </div>
                    <div className="prefix-1 gr-6">
                        <div className="image transform-t-100">
                            <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                <img src="public/images/visualbranding/collage_2_1.jpg" alt="" className="image-resp"
                                     style={{width: "100%"}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/visualbranding/full_2.jpg)"}}></div>
            <div className="section-wrapper">
                <div style={{padding: "0vw 10vw"}}>
                    <div className="row">
                        <div className="gr-7 no-gutter">
                            <div className="image">
                                <div style={{transform: "translate(3vw, -1vw) scale(1.05)"}}>
                                    <img src="public/images/visualbranding/collage_3_1.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                        <div className="prefix-1 gr-4 relative">
                            <div style={{position: "absolute", bottom: "-20vw", padding: "2vw", backgroundColor: "white"}}>
                                <h1>STREET PHOTO<br/>GRAPHY</h1>
                                <p>
                                    Nachdem Vorbild Amerikanischer Street Photography zeigen diese Aufnahmen das
                                    Zusammenspiel des öffentlichen Verkehrs. Dabei sind abgelichtete Menschen nicht als
                                    Privatpersonen gemeint, sondern als anonyme Figuren einer allgemeinen menschlichen
                                    Situation. Street Photography zeigt nicht Person in einer Pose sondern eine
                                    Grundsituation des Alltags im öffentlichen Raum. Sie ist das Produkt von Zufall und
                                    schneller Erfassung des besonderen Moments. <br/><br/>Joel Kernasenko´s Vertrautheit mit dem
                                    Thema
                                    kommt in diesen Bildern besonders zum Ausdruck und zeigt eine andere künstlerische
                                    Seite
                                    seiner Arbeit.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{transform: "translate(0px, -203px)"}}>
                        <div className="row">

                            <div className="gr-6 no-gutter" style={{transform: "translate(-50px, 280px)"}}>
                                <div className="image">
                                    <img src="public/images/visualbranding/collage_3_3.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                            <div className="gr-6 no-gutter"
                                 style={{zIndex: 4, transform: "translate(5vw, 50px)"}}>
                                <div className="image">
                                    <img src="public/images/visualbranding/collage_3_2.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/visualbranding/full_3.jpg)"}}></div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/visualbranding/full_4.jpg)"}}></div>

            <div className="row">
                <div className="gr-6 no-gutter">
                    <div className="image">
                        <img src="public/images/visualbranding/half_1_1.jpg" alt="" className="image-resp"/>
                    </div>
                </div>
                <div className="gr-6 no-gutter">
                    <div className="image">
                        <img src="public/images/visualbranding/half_1_2.jpg" alt="" className="image-resp"/>
                    </div>
                </div>
            </div>

            <div className="section-wrapper">
                <div style={{padding: "0vw 10vw"}}>
                    <div className="row">
                        <div className="gr-6 no-gutter">
                            <div className="image">
                                <img src="public/images/visualbranding/collage_4_1.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                        <div className="gr-6 no-gutter" style={{transform: "translate(-50px, 280px)"}}>
                            <div className="image">
                                <img src="public/images/visualbranding/collage_4_2.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                        <div className="gr-6 no-gutter" style={{zIndex: 4, transform: "translate(80px, 50px)"}}>
                            <div className="image">
                                <img src="public/images/visualbranding/collage_4_3.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/visualbranding/full_5.jpg)"}}></div>

            <div className="next animate">
                <div className="row">
                    <div className="gr-12">
                        <a href="#/categories/storytelling">
                            <h1>NEXT</h1>
                        </a>
                    </div>
                </div>
            </div>

        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/categories/visualbranding.jsx